"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const Input_1 = require("./Input");
const styles_1 = require("../../styles");
const Checkbox = ({ name, label, defaultChecked = false, required = false, disabled = false, readOnly = null, onChange = null, col = 12, register = Input_1.noRegister, textColor = 'darkred', bgColor = 'background', error }) => {
    const requireProps = typeof required === 'boolean' ? { required } : required;
    const { onChange: registerOnChange, onBlur: registerOnBlur, name: registerName, ref: registerRef } = register(name, Object.assign({}, requireProps));
    const [checked, setChecked] = (0, react_1.useState)(defaultChecked);
    const handleChange = e => {
        col;
        registerOnChange && registerOnChange(e);
        onChange && onChange(e);
        setChecked(e.target.checked);
    };
    return ((0, jsx_runtime_1.jsxs)(Label, Object.assign({ "$col": col, "$bgColor": bgColor, "$textColor": textColor, "$checked": checked }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({}, registerRef && { ref: registerRef }, { type: 'checkbox', name: registerName !== null && registerName !== void 0 ? registerName : name, required: required, readOnly: readOnly, disabled: disabled, onChange: handleChange, "aria-invalid": !!error }, defaultChecked && { defaultChecked: checked })), (0, jsx_runtime_1.jsx)(TickBox, {}), (0, jsx_runtime_1.jsx)("span", { children: label })] })));
};
exports.Checkbox = Checkbox;
const Label = styled_components_1.default.label `
  align-items: flex-start;
  color: ${({ theme, $textColor }) => theme.colors[$textColor]};
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
  padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
  position: relative;
  width: 100%;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
    padding: 0 ${(0, styles_1.vw)(4.25, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-bottom: ${(0, styles_1.vw)(30, 'desktop')};
    padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    width: ${({ $col }) => typeof $col === 'number' ? `${100 * $col / 12}%` : $col};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    margin-bottom: 30px;
    padding: 0 12px;
  }

  > div {
    border-color: ${({ theme }) => theme.colors['red']};
  }

  input {
    opacity: 0;
    position: absolute;
    user-select: none;
    visibility: hidden;

    + div {
      background-color: ${({ theme, $checked }) => $checked ? theme.colors['red'] : 'transparent'};
    }
  }

  &:hover {
    input + div {
      opacity: .7;
    }
  }

  span {
    ${(0, styles_1.getP15_5)()}
    display: inline-block;
    margin-top: 3px;
    user-select: none;
  }
`;
const TickBox = styled_components_1.default.div `
  border: 1px solid;
  border-radius: 2px;
  height: 16px;
  margin-right: ${(0, styles_1.vw)(10, 'mobile')};
  position: relative;
  transition: 250ms background-color linear, 250ms opacity linear;
  user-select: none;
  width: 16px;

  ${styles_1.mq.greaterThan('nexus7')} {
    margin-right: ${(0, styles_1.vw)(10, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    margin-right: ${(0, styles_1.vw)(10, 'desktop')};
  }

  ${styles_1.mq.greaterThan('large-screen')} {
    margin-right: 10px;
  }
`;
